module.exports = __webpack_public_path__ + "static/media/imagen2x1.c6ff72bd.png";